import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export const ViolationTooltip = ({ exp, children }) => {
  if (!exp.policy_status || exp.policy_status === "ok") return children;
  const isViolation = exp.policy_status === "violation";
  const detail = isViolation
    ? exp.violation_reason || "This expense breaks a workspace policy."
    : "Aria is waiting on more information from the employee before this expense can pass policy.";
  return (
    <Tooltip delayDuration={120}>
      <TooltipTrigger asChild>
        <span className="inline-flex cursor-help" data-testid={`violation-tooltip-trigger-${exp.id}`}>{children}</span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[300px] border border-[#2a2a2a] bg-[#1c1c1c] px-3.5 py-2.5 text-white shadow-[0_16px_40px_rgba(0,0,0,0.6)]">
        <div className={`text-[10.5px] font-semibold uppercase tracking-wider ${isViolation ? "text-[#F87171]" : "text-[#FBBF24]"}`}>
          {isViolation ? "Policy violation" : "Needs info"}
        </div>
        {exp.policy_name && <div className="mt-1 text-[11px] font-medium text-[#7FAEF9]">{exp.policy_name}</div>}
        <div className="mt-1 text-[11.5px] leading-relaxed text-[#d4d4d4]">{detail}</div>
      </TooltipContent>
    </Tooltip>
  );
};
